// @flow
export function isUndefined(value): boolean {
  return value === undefined
}

export const fixMileageAllianzPillow = (productDescriptorValues, enabledCalculators) => {
  if (typeof productDescriptorValues.mileagePerYear === 'undefined') {
    if (
      (productDescriptorValues.type === 'car' || productDescriptorValues.type === 'van') &&
      (enabledCalculators.includes('CarAllianz') ||
        enabledCalculators.includes('CarPillow'))
    ) {
      productDescriptorValues.mileagePerYear = 12500
    } else if (enabledCalculators.includes('CarPillow')) {
      if (productDescriptorValues.type === 'motorcycle') {
        productDescriptorValues.mileagePerYear = 5000
      } else {
        productDescriptorValues.mileagePerYear = 15000
      }
    }
  }
  return productDescriptorValues
}

export const parseApiError = (apiValidationErrors: Object[]): Object[] => {
  const apiErrors = []
  apiValidationErrors.forEach((err) => {
    let match = /calculator.errors.([a-z_.]*)(;(.*))*/g.exec(err.validationError)
    if (!match) {
      match = /[\s\S]([a-z_.]*)(;(.*))*/g.exec(err.validationError)
    }
    let params = (match && typeof match[3] === 'string' && match[3].replace(/(, )/g, ';')) || ''
    params = params.split(',')

    if (params.length >= 2 && params[1] === '621422') {
      // bad email Pillow
      apiErrors.push({
        key: '621422',
        translationKey: match && match[1],
        translationParams: params.reduce((acc, param, index) => {
          acc[`$${index + 1}`] = param
          return acc
        }, {}),
      })
    }
  })
  return apiErrors
}
